import React from 'react'

import { Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useExecutionForm } from '../_form/ExecutionFormHandler'
import CategoryCard from './CategoryCard'

const CategoriesList = props => {
  const { categories } = useExecutionForm()

  return (
    <Grid align="stretch" justify="flex-start" direction="column" gap={0.5} minHeight="auto">
      {categories.map(category => (
        <CategoryCard key={category.id} category={category} {...props} />
      ))}
    </Grid>
  )
}

export default CategoriesList
